import { PopupContainer } from './common'

export const MlMapCardSkeleton = () => (
  <PopupContainer className="flex flex-col animate-pulse-fast">
    <div className="h-[130px] bg-neutrals-700 opacity-[0.8]" />
    <div className="flex flex-col m-2.5 mt-3.5 flex-1">
      <div className="h-4.5 w-[95%] bg-neutrals-800 opacity-[0.6]" />
      <div className="h-2.5 w-[75%] mt-3.5 bg-neutrals-700 opacity-[0.4]" />
      <div className="h-2.5 w-[75%] mt-1 bg-neutrals-700 opacity-[0.4]" />
      <div className="h-2.5 w-[75%] mt-1 bg-neutrals-700 opacity-[0.4]" />
      <div className="flex-1" />
      <div className="h-7.5 bg-neutrals-700 opacity-[60%]" />
    </div>
  </PopupContainer>
)
